import React from "react"
import { ModalBox, customModalStyles } from "./styles"
import { useDispatch, useSelector } from "react-redux"
import { Box, Button, Modal, Typography } from "@mui/material"
import { closeChooseModal } from "../../../../Infrastructure/States/authModalsSlice"
import CloseIcon from "@mui/icons-material/Close";


export const StripeOnboardingCompleteModal = () => {
    const dispatch = useDispatch()
    const isOpenModal = useSelector((state) => state.auth.isOpenModal)
    const handleCloseModal = () => {
        dispatch(closeChooseModal())
    }
    const handleButton = () => {
        window.location.hash = 'earnings'
        dispatch(closeChooseModal())
    }
    return (
        <Modal
            open={isOpenModal}
            disableScrollLock
            onClose={handleCloseModal}
            aria-labelledby="login-modal-title"
            aria-describedby="login-modal-description"
            sx={customModalStyles.modal}
            BackdropProps={{
                sx: customModalStyles.backdrop,
            }}
        >
            <ModalBox>
                <Box
                    pb={1}
                    pt={1}
                    onClick={handleCloseModal}
                    sx={{
                        position: "relative",
                        top: "9px",
                        right: "-142px",
                        cursor:"pointer"
                    }}
                >
                    <CloseIcon/>
                </Box>
                <Box display={'flex'} flexDirection={'column'} gap={4}>
                    <Typography textAlign={'center'} mt={4}>
                        Stripe onboarding must be completed before publishing course
                    </Typography>
                    <Button variant="contained" color="primary" onClick={() => handleButton()}>
                        Complete Stripe Onboarding
                    </Button>
                </Box>
            </ModalBox>
        </Modal>
    )
}
